import { ArrowRight } from "lucide-react";

const LandingCta = () => {
  const scrollToForm = () => {
    document.getElementById("growth-analysis")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-16 md:py-20 bg-hero-bg">
      <div className="max-w-2xl mx-auto section-padding text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-hero-foreground tracking-tight mb-3">
          See Where Your Practice Stands
        </h2>
        <p className="text-hero-foreground/60 mb-8 leading-relaxed">
          Get your score. See what's broken. Fix it with a clear plan.
        </p>
        <button
          onClick={scrollToForm}
          className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-lg text-base font-semibold hover:bg-accent/90 transition-all duration-200 active:scale-[0.97] shadow-lg shadow-accent/25"
        >
          Start My Growth Analysis
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};

export default LandingCta;
